import React, { useCallback } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import Field from '../../../../../../../components/Form/Field'

import { usePurifiedFormik } from '../../../../../../../hooks/formHooks/usePurifiedFormik'

import { clearUpdateAssetGroup, updateAssetGroup } from '../../../../../../../modules/actions/assets'
import {
  updateAssetGroupErrorSelector,
  updateAssetGroupIsLoadingSelector,
  updateAssetGroupWasUpdatedSelector
} from '../../../../../../../modules/selectors/assets'
import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { HISTORY_META_EDIT_SECTION } from '../../../../../../../constants/changeHistory'
import { CLICK_THROUGH_LINK } from '../../../../fields'
import { getInitialValues, validationSchema } from './fields'

const LinkSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const dispatch = useDispatch()

  const { id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const assetGroupWasUpdated = useSelector(updateAssetGroupWasUpdatedSelector)

  const handleSubmit = useCallback(
    values => {
      dispatch(
        updateAssetGroup(
          {
            account: adAccount,
            [CLICK_THROUGH_LINK]: [values[CLICK_THROUGH_LINK]],
            ...(isInternalAssetGroup && { internal: true }),
            meta: {
              [HISTORY_META_EDIT_SECTION]: title
            }
          },
          assetGroupId
        )
      )
    },
    [dispatch, adAccount, isInternalAssetGroup, assetGroupId, title]
  )

  const initialValues = getInitialValues(editItemData)

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit,
    validationSchema
  })

  const purifiedFormik = usePurifiedFormik(formik)

  const clearSubmitHandler = useCallback(() => {
    dispatch(clearUpdateAssetGroup())
  }, [dispatch])

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={updateAssetGroupIsLoadingSelector}
      errorSelector={updateAssetGroupErrorSelector}
      successSubmit={assetGroupWasUpdated}
      clearEditItem={clearSubmitHandler}
      {...formProps}
    >
      <Field formik={formik} name={CLICK_THROUGH_LINK} placeholder="Click Through Link" autoComplete="off" />
    </EditForm>
  )
}

export default LinkSectionForm
